import { COLORS } from '@/styles/colorTheme';
import { Container } from './ThirdTapStyles';
import { useRef, useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

const ThirdTap = ({ isActive = false, children, color = COLORS.Text500, onClick }) => {
  const refEL = useRef<any>(null);
  const [isHover, setIsHover] = useState(false);

  useEffect(() => {
    const instance = refEL.current;

    instance.addEventListener('mouseover', () => {
      setIsHover(true);
    });

    instance.addEventListener('mouseleave', () => {
      setIsHover(false);
    });

    return () => {
      instance.removeEventListener('mouseover', () => {
        setIsHover(true);
      });

      instance.removeEventListener('mouseleave', () => {
        setIsHover(false);
      });
    };
  }, []);

  return (
    <Container ref={refEL} isActive={isActive} color={color} onClick={onClick}>
      <div
        className={cn(
          isHover ? `text-[${color}]` : isActive ? 'text-primary-500' : `text-[${color}]`,
          'text-sm',
        )}
      >
        {children}
      </div>
    </Container>
  );
};

export default ThirdTap;
